var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"doubleInput",staticClass:"double-input"},[_c('uInput'),_vm._v(" "),_c('span',{staticClass:"ledge"},[_vm._v("---")]),_vm._v(" "),_c('uInput')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ec3c01d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uInput/doubleInput.vue
// module id = caZ8
// module chunks = 33